import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

export type VehicleRequestType = 'make' | 'model';
export type VehicleRequestStatus = 'pending' | 'approved' | 'rejected';

export interface SubmitVehicleRequestPayload {
  type: VehicleRequestType;
  name: string;
  /** Required when type is 'model' */
  makeId?: string;
  makeName?: string;
  notes?: string;
}

export interface SubmitVehicleRequestResponse {
  requestId: string;
  alreadyRequested: boolean;
  requestCount: number;
  status: VehicleRequestStatus;
}

export interface VehicleRequest {
  id: string;
  type: VehicleRequestType;
  name: string;
  makeId?: string;
  makeName?: string;
  notes?: string;
  status: VehicleRequestStatus;
  requestCount: number;
  requestedByCount: number;
  firstRequestedAt: string;
  lastRequestedAt: string;
  resolvedAt?: string;
  adminNotes?: string;
  rejectionReason?: string;
}

export interface VehicleRequestQueueParams {
  page?: number;
  limit?: number;
  status?: VehicleRequestStatus | 'all';
  type?: VehicleRequestType | 'all';
  search?: string;
}

export interface VehicleRequestQueueResponse {
  data: VehicleRequest[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const vehicleRequestService = {
  async submit(payload: SubmitVehicleRequestPayload): Promise<SubmitVehicleRequestResponse> {
    const { data } = await axiosInstance.post(API_ENDPOINTS.VEHICLE_REQUESTS.SUBMIT, payload);
    return data?.data ?? data;
  },

  async getQueue(params: VehicleRequestQueueParams = {}): Promise<VehicleRequestQueueResponse> {
    const { data } = await axiosInstance.get(API_ENDPOINTS.VEHICLE_REQUESTS.GET_QUEUE, { params });
    return data?.data ?? data;
  },

  async approve(id: string): Promise<void> {
    await axiosInstance.post(API_ENDPOINTS.VEHICLE_REQUESTS.APPROVE(id));
  },

  async reject(id: string, rejectionReason: string): Promise<void> {
    await axiosInstance.post(API_ENDPOINTS.VEHICLE_REQUESTS.REJECT(id), { rejectionReason });
  },
};
